import * as types from './types'

const mutations = {
  [types.SET_USER] (state, user) {
    state.user = user
  },
  [types.SET_CURRENT_COMPANY] (state, currentCompanyId) {
    state.currentCompanyId = currentCompanyId
  },
  [types.SET_ABILITIES] (state, payload) {
    state.abilities = payload
  },
  [types.SET_IS_AUTHENTICATED] (state, payload) {
    state.isAuthenticated = payload
  },
  [types.SET_SETTINGS] (state, settings) {
    state.settings = settings
  },
  [types.SET_LOADING] (state, payload) {
    state.isLoading = payload
  }
}

export default mutations
